import type { ReactNode } from 'react';
import type { Control, FieldPath, FieldValues } from 'react-hook-form';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/shared/ui/form';
import { Input } from '@/shared/ui/primitives/input';

/** Props de um campo de texto do formulário de auth. */
export interface TextFieldProps<TValues extends FieldValues> {
  control: Control<TValues>;
  name: FieldPath<TValues>;
  label: string;
  type: 'email' | 'password';
  autoComplete: 'email' | 'username' | 'current-password' | 'new-password';
}

/** Campo com rótulo e mensagem de erro (React Hook Form + shadcn/ui). */
export function TextField<TValues extends FieldValues>({
  control,
  name,
  label,
  type,
  autoComplete,
}: TextFieldProps<TValues>): ReactNode {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <FormControl>
            <Input type={type} autoComplete={autoComplete} {...field} />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
